import * as React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";
import UnderLine from "../../components/AnimatedUnderLine";
import { Auth } from "aws-amplify";
import getEnvVars from "../../enviroment";
import Colors from "../../utilities/Color";
import GenericButton from "../../components/GenericButton";

const awsConfig = getEnvVars().awsConfig;
Auth.configure(awsConfig);

export default function LoginModeChoiceScreen() {
  const navigation = useNavigation();

  return (
    <View style={GlobalStyles.containerMB}>
      <ScrollView>
        <View style={GlobalStyles.bodyContainerT}>
          <View style={styles.HbuttonBar}>
            <TouchableOpacity
              style={styles.HbackButtonStyle}
              onPress={() => navigation.goBack()}
            >
              <Ionicons
                name="md-arrow-back"
                size={20}
                style={styles.HbackArrow}
              />
            </TouchableOpacity>
            <View>
              <Text style={styles.HTextStyle}>LOG IN</Text>
            </View>
            <View style={styles.HbackButtonStyle}></View>
          </View>
          <View style={styles.container}>
            <View style={{ marginTop: 25 }}>
              <GenericButton
                buttonText="WITH PHONE"
                onPress={() =>
                  navigation.navigate("Login", {
                    formMode: "p",
                    savedUsername: "",
                  })
                }
              />
            </View>

            <View style={{ marginTop: 50 }}>
              <GenericButton
                buttonText="WITH EMAIL"
                onPress={() =>
                  navigation.navigate("Login", {
                    formMode: "e",
                    savedUsername: "",
                  })
                }
              />
            </View>
            <View style={{ marginTop: 225 }}>
              <GenericButton
                buttonColor={null}
                borderWidth={1}
                borderColor={Colors.DARKGRAY}
                buttonText="OTHER OPTIONS"
                onPress={() => navigation.navigate("LoginModeChoiceSocial")}
              />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  linkStyle: {
    marginBottom: 25,
    marginTop: 35,
  },
  buttonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  container: {
    paddingTop: 20,
    marginLeft: 30,
    marginRight: 30,
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
  },
  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 25,
  },
  HbuttonBarConf: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
  },
  HbackArrow: {
    color: "#fff",
  },
  HbackArrowBlack: {
    color: "#000",
  },
  HbackButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },
  buttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },
});
